"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VictoryBoxPlot = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _reactNativeSvg = require("react-native-svg");
var _es = require("victory-box-plot/es");
var _victoryLabel = require("./victory-label");
var _victoryContainer = require("./victory-container");
var _border = require("./victory-primitives/border");
var _whisker = require("./victory-primitives/whisker");
var _lineSegment = require("./victory-primitives/line-segment");
var _wrapCoreComponent = require("../helpers/wrap-core-component");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const VictoryBoxPlot = exports.VictoryBoxPlot = (0, _wrapCoreComponent.wrapCoreComponent)({
  Component: _es.VictoryBoxPlot,
  defaultProps: {
    ..._es.VictoryBoxPlot.defaultProps,
    maxComponent: /*#__PURE__*/_react.default.createElement(_whisker.Whisker, null),
    maxLabelComponent: /*#__PURE__*/_react.default.createElement(_victoryLabel.VictoryLabel, null),
    medianComponent: /*#__PURE__*/_react.default.createElement(_lineSegment.LineSegment, null),
    medianLabelComponent: /*#__PURE__*/_react.default.createElement(_victoryLabel.VictoryLabel, null),
    minComponent: /*#__PURE__*/_react.default.createElement(_whisker.Whisker, null),
    minLabelComponent: /*#__PURE__*/_react.default.createElement(_victoryLabel.VictoryLabel, null),
    q1Component: /*#__PURE__*/_react.default.createElement(_border.Border, null),
    q1LabelComponent: /*#__PURE__*/_react.default.createElement(_victoryLabel.VictoryLabel, null),
    q3Component: /*#__PURE__*/_react.default.createElement(_border.Border, null),
    q3LabelComponent: /*#__PURE__*/_react.default.createElement(_victoryLabel.VictoryLabel, null),
    containerComponent: /*#__PURE__*/_react.default.createElement(_victoryContainer.VictoryContainer, null),
    groupComponent: /*#__PURE__*/_react.default.createElement(_reactNativeSvg.G, null),
    width: _reactNative.Dimensions.get("window").width
  }
});